export const apiRoot = "https://donate.kachanovcraft.com/api/";

export function fetchApiGet(route, navigateFunc) {
  let headers = {};

  let token = localStorage.getItem("token");
  if (token) {
    headers["Authorization"] = "Bearer " + localStorage.getItem("token");
  }

  return fetch(apiRoot + route, {
    headers: headers,
  }).then(async (response) => {
    return [response, await response.json()];
  });
}

export function fetchApiPost(route, body = {}, json = false) {
  let headers = {
    "Content-Type": "application/json",
  };

  let token = localStorage.getItem("token");
  if (token) {
    headers["Authorization"] = "Bearer " + localStorage.getItem("token");
  }

  return fetch(apiRoot + route, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(body),
  }).then(async (response) => {
    return [response, json ? await response.json() : await response.text()];
  });
}
